import Tooltip, { DisputedPaperTooltip } from "components/Popover";
import useLabels from "hooks/useLabels";
import Tag from "../Tag";

interface DisputedPaperTagProps {
  reason?: string;
  url?: string;
  isCompact?: boolean;
}

function DisputedPaperTag({ reason, url, isCompact }: DisputedPaperTagProps) {
  const [pageLabels] = useLabels("tooltips.disputed");

  return (
    <Tooltip
      interactive
      maxWidth={306}
      appendToParent
      className="flex items-center"
      disabled={!reason || !url}
      tooltipContent={
        <DisputedPaperTooltip reason={reason ?? ""} url={url ?? ""} />
      }
    >
      {isCompact ? (
        <div className="p-1">
          <i className="text-base icon-triangle-alert text-chart-red-base" />
        </div>
      ) : (
        <Tag
          label={pageLabels["tag"]}
          icon="icon-triangle-alert"
          variant="NO"
          data-testid="disputed-paper-tag"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        />
      )}
    </Tooltip>
  );
}

export default DisputedPaperTag;
